import React from 'react';

export type LinkableProps = {
  finalUrl: string;
};

export const withLink = <P extends object>(WrappedComponent: React.ComponentType<P>) => {
  const HoC = React.memo((props: P & LinkableProps) => (
    <a
      className="placement-link"

      href={props.finalUrl}
      rel="noopener noreferrer"
      target="_blank"
    >
      <WrappedComponent {...props} />
    </a>
  ));


  return HoC;
};
